import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useFetchSubstage } from "./useFetchSubstage";

export const getBasketSizeWarningAcknowledgmentKey = (shiftId: string) =>
  `basket-size-warning-acknowledgment-done-shift-id-${shiftId}`;

export function setBasketSizeWarningAcknowledgment(shiftId: string) {
  sessionStorage.setItem(getBasketSizeWarningAcknowledgmentKey(shiftId), "true");
}

export function isBasketSizeWarningAcknowledgmentDone(shiftId: string): boolean {
  try {
    const isAcknowledgmentDone = sessionStorage.getItem(
      getBasketSizeWarningAcknowledgmentKey(shiftId)
    );

    if (isDefined(isAcknowledgmentDone) && isAcknowledgmentDone === "true") {
      return true;
    }
  } catch {
    // If the session storage is not available, we return true. This is important because
    // if we don't know acknowledgement status, so we don't want to show the basket size warning infinitely
    return true;
  }

  return false;
}

export function useIsBasketSizeWarningAcknowledgmentNeeded(params: { shiftId: string }): boolean {
  const worker = useDefinedWorker();
  const subStageValues = useFetchSubstage();
  const { enabled: isTiersEnabled } = useCbhFlag(CbhFeatureFlag.CONFIG_TIERS, {
    defaultValue: { enabled: false },
  });

  const { shiftId } = params;

  if (isBasketSizeWarningAcknowledgmentDone(shiftId) || isTiersEnabled) {
    return false;
  }

  if (
    subStageValues.data?.name === "LIMITED" &&
    subStageValues.data?.accessMetadata?.basketSize &&
    isDefined(worker.activeClaimedShifts)
  ) {
    return worker.activeClaimedShifts + 1 === subStageValues.data?.accessMetadata?.basketSize;
  }

  return false;
}
